import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ScriptService } from 'src/app/shared/services/square/script.service';
import { PurchaseRequestService } from 'src/app/shared/services/purchase-request.service';
import { environment } from 'src/environments/environment';
import { ResponseOnHold } from 'src/app/core/enums/response-on-hold.enum';
import { Payment } from '../card/response';
import { CompanyParamsService } from '../../../../core/services/company-params.service';
import { PaymentMethodTypeEnum } from '../../../../core/enums/payment-methods-type.enum-';
import { UtilClass } from 'src/app/core/classes/Util.class';
import { NumberTypeEnum } from 'src/app/core/enums/payflow/number-type.enum';
import { PurchaseContactPerson } from 'src/app/core/models/purchase/purchase-contact-person';

declare function initPayments(applicationId: any, locationId: any): any;
declare function handlePaymentMethodSubmission(apiPayment: any, card: any, payments: any, body: any, verificationDetails: any): void;
declare function getPayments(): any;
declare function getCard(): any;

@Component({
  selector: 'app-square-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {

  payWidthCard: boolean = true;
  paymentResult: any;
  applicationId:string = '';
  locationId: string = '';
  note:string = '';
  paymentMethodTypeEnum = PaymentMethodTypeEnum;

  @Input()
  valuePayWidthCard: number = 0;

  @Input() termsCondictios = false;

  @Output() public cabinWasReservedOrHttpError: EventEmitter<any> =
    new EventEmitter();

  @Output() public successPaymentRequest: EventEmitter<any> =
    new EventEmitter();



  constructor(
    private purchaseRequestService: PurchaseRequestService,
    private scriptService: ScriptService,
    private router: Router,
    public companyParamsService: CompanyParamsService,
  ) {
  }

  ngOnInit(): void {

    const squarePaymeObj = this.getSquarePayment();

    this.scriptService.loadScript('square');
    this.applicationId = squarePaymeObj.objectConfiguration.applicationId;
    this.locationId = squarePaymeObj.objectConfiguration.locationId;
    this.note = this.purchaseRequestService.getNoteSquare();
  }

  get getPayWidthCard() {
    return this.payWidthCard;
  }

  deactivatePayWidthCard(): void {
    this.payWidthCard = false;
  }

  getInitPayments() {
    initPayments(this.applicationId, this.locationId);
    this.deactivatePayWidthCard();
  }

  getValue() {
    return this.valuePayWidthCard;
  }

  isMyInterface(json: any): json is Payment {
    return typeof json.key === "string";
  }

  getBody():string{
    let uuid:string = window.crypto.randomUUID();
    return JSON.stringify({
     locationId: this.locationId,
     idempotencyKey: uuid,
     referenceId: uuid,
     note: this.note,
     amount: this.getValue(),
     currency:'USD'
   });
 }

 getVerificationDetails():string{
  let purchaseContactPerson:PurchaseContactPerson|undefined = this.purchaseRequestService.getPurchaseContactPerson();
  let amountStr = String(this.purchaseRequestService.getTotalPrice())
  return JSON.stringify({
    amount: amountStr,
    billingContact: {
      addressLines: purchaseContactPerson?.purchasePassengerInformation?.address,
      familyName: purchaseContactPerson?.firstName,
      givenName: purchaseContactPerson?.lastName,
      email: purchaseContactPerson?.email,
      country: 'GB',
      phone: purchaseContactPerson?.phone,
      region: 'LND',
      city: 'London',
    },
    currencyCode: 'GBP',
    intent: 'CHARGE',
  });
}

  async getHandlePaymentMethodSubmission() {
    let result;
    let body = this.getBody();
    let verificationDetails = this.getVerificationDetails();
    try {
      const url = environment.ngGtcPaySquare.apiUrl+this.getUrlParameter();
      result = await handlePaymentMethodSubmission(url, getCard(), getPayments(), body, verificationDetails);
      this.paymentResult = JSON.stringify(result);
      const data = JSON.parse(this.paymentResult) as Payment;
      if (data.status === 'COMPLETED') {
        const blockDepartureResponse: any = await this.purchaseRequestService
          .requestBlockCabinOnHold(this.purchaseRequestService.getPercentUsed());
        const isblockDeparture: boolean =
          this.purchaseRequestService.setBlockDeparture(blockDepartureResponse);
        const isBlockDepartureSuccess =
          isblockDeparture === true &&
          this.purchaseRequestService.isRequestBlockDepartureSuccess();
        if (isBlockDepartureSuccess === false) {
          this.cabinWasReservedOrHttpError.emit(ResponseOnHold.RESERVED_ERROR);
        } else {
          this.successPaymentRequest.emit();
        }
      }
    } catch (error) {
      console.error(error);
      this.cabinWasReservedOrHttpError.emit(ResponseOnHold.RESERVED_ERROR);
    }
  }

  private getSquarePayment(): any {
    const index = this.companyParamsService.company.paymentMethods.findIndex(
      (item: any) =>
        Number(item.type) === Number(this.paymentMethodTypeEnum.SQUARE_CARD)
    );
    return index
      ? this.companyParamsService.company.paymentMethods[index]
      : undefined;
  }

  private getUrlParameter(): string {
    try {
      const numberType: NumberTypeEnum = environment.ngGtcPaySquare.numberType;
      return UtilClass.generateRandomNumberByType(numberType) + "";
    } catch (error) {
      return '';
    }
  }
}

